import {makeSplitPoint} from 'plugins/react'

const I18nEditModalAsync = makeSplitPoint(() => import('./I18nEditModal'), {
	ssr: false,
})

export default I18nEditModalAsync
